import { NgModule } from '@angular/core';
import { NavigationEnd, PreloadAllModules, Router, RouterModule, Routes, UrlSegment } from '@angular/router';
import { AuthGuard } from './guards/auth.guard';
import { PouchService } from './services/pouch-service';

const routes: Routes = [
  {
    path: 'AddEntityPage',
    canActivate: [AuthGuard],
    loadChildren: () => import('./add-entity/add-entity.module').then((m) => m.AddEntityPageModule),
  },
  {
    path: 'HtmlEditorPage',
    canActivate: [AuthGuard],
    loadChildren: () => import('./htmleditor/htmleditor.module').then((m) => m.HtmlEditorPageModule),
  },
  {
    path: 'CalendarPage',
    canActivate: [AuthGuard],
    loadChildren: () => import('./calendar/calendar.module').then((m) => m.CalendarPageModule),
  },
  {
    path: 'PrintReceiptPage',
    canActivate: [AuthGuard],
    loadChildren: () => import('./print-receipt/print-receipt.module').then((m) => m.PrintReceiptPageModule),
  },
  /* {
    path: 'appointment/:database',
    canActivate: [AuthGuard],
    loadChildren: () => import('./calendar/calendar.module').then((m) => m.CalendarPageModule),
  }, */
  {
    path: 'FileViewerPage',
    canActivate: [AuthGuard],
    loadChildren: () => import('./fileviewer/fileviewer.module').then((m) => m.FileViewerPageModule),
  },
  {
    path: 'CustomerManagementPage',
    canActivate: [AuthGuard],
    loadChildren: () => import('./customer_management/customer_management.module').then((m) => m.CustomerManagementPageModule),
  },
  {
    path: 'LoginCustomerPage',
    canActivate: [AuthGuard],
    loadChildren: () => import('./login-customer/login-customer.module').then((m) => m.LoginCustomerPageModule),
  },
  {
    path: 'PrintEntityPage',
    canActivate: [AuthGuard],
    loadChildren: () => import('./print-entity/print-entity.module').then((m) => m.PrintEntityPageModule),
  },
  {
    path: ':app/:database/quotation/:maintenance_id/:contractor_id',
    canActivate: [AuthGuard], // pass the database name and the prescription id to the viewEntity page
    loadChildren: () => import('./quote/quote.module').then((m) => m.QuotePageModule),
  },
  {
    path: ':mode/:database/:id',
    canActivate: [AuthGuard], // pass the database name and the prescription id to the viewEntity page
    loadChildren: () => import('./view-entity/view-entity.module').then((m) => m.ViewEntityPageModule),
  },
  {
    matcher: (url) => {
      if (url.length === 1 && url[0].path.includes('$')) {
        return {
          consumed: url, // Mark this segment as consumed
          posParams: {
            database: new UrlSegment(url[0].path, {}), // Pass the database as a parameter
          },
        };
      }
      // if the url[0].path does not contain "Page" and is not empty, then it is a database name
      else if (url.length === 1 && url[0].path && !url[0].path.includes('Page')) {
        return {
          consumed: url, // Mark this segment as consumed
          posParams: {
            database: new UrlSegment(url[0].path, {}), // Pass the database as a parameter
          },
        };
      }
      return null; // Do not match this route otherwise
    },
    canActivate: [AuthGuard],
    loadChildren: () => import('./login-customer/login-customer.module').then((m) => m.LoginCustomerPageModule),
  },
  {
    path: '',
    loadChildren: () => import('./login-customer/login-customer.module').then((m) => m.LoginCustomerPageModule),
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })],
  exports: [RouterModule],
})
export class AppRoutingModule {
  constructor(private router: Router, private db: PouchService) {
    this.router.events.subscribe((event) => {
      // Handle wildcard route by navigating to the viewEntity page
      if (event instanceof NavigationEnd) {
        const url = event.urlAfterRedirects;
        if (url !== '/viewEntityPage') {
          //this.router.navigate(['/viewEntityPage'], { skipLocationChange: true });
        }
      }
    });
  }
}
